export default __webpack_public_path__ + "static/media/sweets.ba98826a.svg";